/** @flow */

import { beginRequest, completeRequest } from "@store/utils";
import type { DataSecurityState } from "./types";

const startRequest = beginRequest(["requestsInProgress"]);
const finishRequest = completeRequest(["requestsInProgress"]);

export const setLoading = (state: DataSecurityState) => () => startRequest(state);

export const onGetSecuritySettingsSuccess = (state: DataSecurityState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  securitySettings: payload,
});

export const onGetSecuritySettingsError = (state: DataSecurityState) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  error: payload,
  securitySettings: null,
});

export const onUpdateSecuritySettingsError = (state: DataSecurityState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  error: payload,
  securitySettings: null,
});

export const onGetEmployeeSecuritySchemaSuccess = (state: DataSecurityState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  schema: payload,
});

export const onGetEmployeeSecuritySchemaError = (state: DataSecurityState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  error: payload,
});
